/* eslint-disable */

/**
 * 该文件为脚本自动生成文件，请勿随意修改。如需修改请联系 PMC
 * */

import { ShapeEnum } from '../common/common';

export interface TdAvatarGroupProps {
  /**
   * 图片之间的层叠关系，可选值：左侧图片在上和右侧图片在上
   * @default 'left-up'
   */
  cascading?: {
    type: StringConstructor;
    value?: CascadingValue;
  };
  /**
   * 头像数量超出时，会出现一个头像折叠元素。该元素内容可自定义。默认为 `+N`。示例：`+5`，`...`, `更多`
   */
  collapseAvatar?: {
    type: StringConstructor;
    value?: string;
  };
  /**
   * 能够同时显示的最多头像数量
   */
  max?: {
    type: NumberConstructor;
    value?: number;
  };
  /**
   * 形状。优先级低于 Avatar.shape
   */
  shape?: {
    type: StringConstructor;
    value?: ShapeEnum;
  };
  /**
   * 尺寸，示例值：small/medium/large/24px/38px 等。优先级低于 Avatar.size
   * @default ''
   */
  size?: {
    type: StringConstructor;
    value?: string;
  };
}

export type CascadingValue = 'left-up' | 'right-up';
